import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { GroupTreeAssigment } from './grouptreeassigment.entity';
//#endregion

export const GroupTreeAssigmentConfig = {
  name: "GroupTreeAssigment",
  annotations: [],
  fields: {
    groupId: {type: 'Edm.Int32'},
    groupTreeId: {type: 'Edm.Int32'},
    sortValue: {type: 'Edm.Int32'},
    refGroupTreeId: {type: 'Edm.Int32', nullable: false},
    refType: {type: 'services.RefType', nullable: false},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    group: {type: 'entities.schema.Group', navigation: true, field: 'groupId', ref: 'id'},
    groupTree: {type: 'entities.schema.GroupTree', navigation: true, field: 'groupTreeId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<GroupTreeAssigment>;